<!-- Liste des adresses d'un lieu sans filtres -->
<mat-card-content>
    <div class="empty" *ngIf="!listeAdresse || listeAdresse.length === 0"><span [translate]="'lieu.aucuneAdresse'"></span></div>
    <div class="listview" *ngIf="listeAdresse && listeAdresse.length > 0">
        <div class="listview-body">
            <div class="listview-item" *ngFor="let adr of listeAdresse">
                <div class="lvi-content">
                    <div class="avatar"><i class="material-icons-outlined">{{ adresseService.getIconeForTypeAdresse(adr.type) }}</i></div>
                    <div class="lvi-body">
                        <div class="title">
                            <a [routerLink]="" (click)="selectAdresse(adr)">
                                {{ adr.rue ? adr.rue + ', ' : '' }}
                                {{ adr.codePostal ? adr.codePostal + ' ' : '' }}
                                {{ adr.ville ? adr.ville + ', ' : '' }}
                                {{ adr.pays ? adr.pays : '' }}
                            </a>
                        </div>
                        <ul class="lvi-attrs">
                            <li><strong [translate]="'lieu.type.type'"></strong>{{ 'lieu.type.' + adr.type?.toLowerCase() | translate }}</li>
                            <li><strong [translate]="'lieu.actif.actif'"></strong>{{ 'global.' + (adr.actif ? 'oui' : 'non') | translate }}</li>
                            <li *ngIf="adr.isGeolocalisee"><b [translate]="'lieu.geolocalisee'"></b></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-card-content>